module.exports = {
	"name": "html5",
	"type": "adapter",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.1",
	"built": "2017-06-01",
	"repo": "https://bitbucket.org/npaw/html5-adapter-js.git",
	"libVersion": "6.0.1",
	"features": {
		"buffer": "monitor",
		"seek": "native",
		"getters": [
			"getPlayhead",
			"getDuration",
			"getResource"
		]
	},
	"ads": []
};


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0